module.exports = __webpack_public_path__ + "img/Ornamento_Grande.35d2a56c.svg";